export default __webpack_public_path__ + "static/media/flutter.14e4da66.svg";